import { apiClient } from "./client";

export interface RdnPrice {
  ts: string;
  price_uah_per_mwh: number | string;
}

export interface ImbalancePrice {
  ts: string;
  price_uah_per_mwh: number | string;
}

export interface RdnHourDetail {
  ts: string;
  price_uah_per_mwh: number | string | null;
  forecast_uah_per_mwh: number | string | null;
}

export interface RdnDayDetail {
  date: string;
  last_updated_at: string | null;
  trader_fee_pct: number | string | null;
  hours: RdnHourDetail[];
}

export const pricesApi = {
  rdn: (date: string) =>
    apiClient.get<RdnPrice[]>("/rdn-prices", { params: { date } }).then((r) => r.data),

  rdnDayDetail: (date: string) =>
    apiClient
      .get<RdnDayDetail>("/rdn-prices/day-detail", { params: { date } })
      .then((r) => r.data),

  imbalance: (date: string) =>
    apiClient
      .get<ImbalancePrice[]>("/imbalance-prices", { params: { date } })
      .then((r) => r.data),
};
